<template>
  <section class="content goodsClass">
    <el-row style="height: 30px">
      <el-col :span="2">
        <el-button type="success" icon="el-icon-sort-up" size="small" @click="editClass">新增报表</el-button>
      </el-col>
      <el-col :span="2" style="margin-left: 10px">
        <el-button type="danger" icon="el-icon-delete" size="small" @click="delClass">批量删除</el-button>
      </el-col>
      <!-- <el-col :span="2" style="margin-left: 10px">
        <el-button type="primary" icon="el-icon-star-off" size="small" @click="myCollected">我的收藏</el-button>
      </el-col> -->
      <el-col :span="6" style="margin-left: 10px" class="search">
        <el-input
          placeholder="请输入报表名称"
          prefix-icon="el-icon-search"
          style="width:200px;margin-right: 10px;"
          v-model="reportName"
        ></el-input>
        <el-button size="small" @click="searchName" type="primary">搜索</el-button>
      </el-col>
    </el-row>
    <el-table
      ref="ListTable"
      :data="listData"
      border
      v-loading="loading"
      :row-class-name="tableRowClassName"
      tooltip-effect="dark"
      style="margin-top: 10px;text-align: center"
      @selection-change="selectData = arguments[0]"
    >
      <el-table-column type="selection" header-align="center" width="55"></el-table-column>
      <el-table-column header-align="center" label="详情" min-width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="goToReport(scope.row)">查看报表</el-button>
        </template>
      </el-table-column>
      <el-table-column label="报表标题" header-align="center" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.reportTitle }}</template>
      </el-table-column>
      <el-table-column header-align="center" label="报表备注" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.reportRemark}}</template>
      </el-table-column>
      <el-table-column header-align="center" label="创建时间" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.createDatetime}}</template>
      </el-table-column>
      <el-table-column header-align="center" label="系统操作" min-width="120">
        <template slot-scope="scope">
          <el-button type="text" @click="editClass(scope.row)">编辑</el-button>
          <el-button type="text" v-if="scope.row.collected==2" @click="getCollected(scope.row)">收藏</el-button>
          <el-button type="text" v-if="scope.row.collected==1" @click="getCancelCollected(scope.row)">取消收藏</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="margin-top: 10px;text-align: right">
      <el-col :span="24">
        <el-pagination
          @size-change="searchSize"
          @current-change="searchCurrent"
          :current-page="filter.page.pageIndex"
          :page-sizes="[10, 20, 50]"
          :page-size="filter.page.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="filter.page.totalElements"
        ></el-pagination>
      </el-col>
    </el-row>
    <el-dialog
      @colse="init(true)"
      :title="editClassData.title"
      width="50"
      :visible.sync="editClassData.visible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="report-member-rights-form"
        v-loading="editLoading"
        :model="editClassData"
        label-width="90px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="报表类型" prop="reportTitle">
              <el-radio-group v-model="editClassData.reportType">
            <el-radio :label="1">门店报表</el-radio>
            <el-radio :label="2">医生报表</el-radio>
          </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="报表标题" prop="reportTitle">
              <el-input
                size="small"
                :rules="[{required: true, message: '请填写报表标题', trigger: 'blur'}]"
                placeholder="请填写报表标题"
                v-model="editClassData.reportTitle"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="报表备注" prop="reportRemark">
              <el-input
                size="small"
                :rules="[{required: true, message: '请填写报表备注', trigger: 'blur'}]"
                placeholder="请填写报表备注"
                v-model="editClassData.reportRemark"
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="时间范围" prop="repDateType">
              <el-select
                size="small"
                :rules="[{required: true, message: '请选择时间范围', trigger: 'blur'}]"
                v-model="editClassData.repDateType"
                placeholder="请选择时间范围"
              >
                <el-option
                  v-for="(item,index) in repDateTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="时间范围值" prop="repDateNumber">
              <el-input
                size="small"
                type="number"
                :rules="[{required: true, message: '请输入时间范围值', trigger: 'blur'}]"
                placeholder="请输入时间范围值"
                v-model="editClassData.repDateNumber"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="报表导出">
              <el-radio v-model="editClassData.repExport" :label="1">是</el-radio>
              <el-radio v-model="editClassData.repExport" :label="2">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="查询条件">
              <el-radio v-model="editClassData.repParamRequired" :label="1">是</el-radio>
              <el-radio v-model="editClassData.repParamRequired" :label="2">否</el-radio>
            </el-form-item>
          </el-col> -->
          <!-- <el-col :span="12">
            <el-form-item label="报表所属">
              <el-radio v-model="editClassData.plaType" :label="1">平台</el-radio>
              <el-radio v-model="editClassData.plaType" :label="2">门店</el-radio>
              <el-radio v-model="editClassData.plaType" :label="3">慢病</el-radio>
              <el-radio v-model="editClassData.plaType" :label="4">DTP慢病</el-radio>
            </el-form-item>
          </el-col> -->
          <el-col :span="24">
            <el-form-item label="sql内容" prop="repSql">
              <el-input
                type="textarea"
                size="small"
                :rules="[{required: true, message: '请输入', trigger: 'blur'}]"
                v-model="editClassData.reportSql"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editClassData.visible=false">取 消</el-button>
        <el-button type="primary" @click="closeEditClass">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script type="text/babel">
import { Utils } from "@/utils/utils";
import { allReportList, reportGet,reportExport,reportDetail,reportDel,reportEdit,reportAdd} from "@/api/statement"; // 报表统计请求

export default {
  data() {
    return {
      reportName:'',
      filter: {
        page: {
          pageIndex: 1,
          pageSize: 10,
          totalElements: 10,
          myCollected: 2, //我的收藏（默认传 2  ， 点击我的收藏 传 1）
          reportName: null,
        },
      },

      exportLoading: false,
      editLoading: false,
      levelData: [],
      listData: [],
      editClassData: {},
      initData: {
        // repId: "",
        // title: "新增报表",
        visible: false,
        // repTitle: "",
        // repSql: "",
        // repRemark: "",
        // repExport: 1,
        // repParamRequired: 1,
        // repDateType: "",
        // repDateNumber: "",
        // plaType: 1,

        "reportId": '',
        "reportRemark": "",
        "reportSql": "",
        "reportTitle": ""
      },
      categoryParentData: [],
      selectData: [],
      loading: false,
      repDateTypeList: [
        {
          label: "年",
          value: 1,
        },
        {
          label: "月",
          value: 2,
        },
        {
          label: "日",
          value: 3,
        },
        {
          label: "不需要",
          value: 10,
        },
      ],
    };
  },
  mounted() {
    this.init(false);
  },
  watch: {},
  methods: {
    searchName(){
      this.filter.page.reportName = this.reportName;
      this.search();
    },
    getCollected(item){
      let obj={
        repId:item.repId
      }
      // PlatformService.reportCollect(obj).then(res=>{
      //   if(res.errorCode==='0000'){
      //     this.search();
      //     this.$message({
      //     message: '收藏成功',
      //     type: 'success'
      //   });
      //   }
      // })
    },
    getCancelCollected(item){
      let obj={
        repId:item.repId
      }
      // PlatformService.reportCancelCollect(obj).then(res=>{
      //   if(res.errorCode==='0000'){
      //     this.search();
      //     this.$message({
      //     message: '取消收藏成功',
      //     type: 'success'
      //   });
      //   }
      // })
    },
    myCollected() {
      // 我的收藏（默认传 2  ， 点击我的收藏 传 1）
      this.filter.page.myCollected = 1;
      this.search();
    },
    init(closeType) {
      this.search();
      // const vm = this;
      // vm.editClassData = vm.$lodash.clone(vm.initData);
      // if (closeType) {
      //   vm.$refs["report-member-rights-form"].resetFields();
      // }
    },
    tableRowClassName({ row, rowIndex }) {
      //斑马纹
      if (rowIndex === 1) {
        return "warning-row";
      } else if (rowIndex === 3) {
        return "success-row";
      }
      return "";
    },
    goToReport(row) {
      const vm = this;
      vm.$router.push({
        path: "/statement/reportDetails",
        query: {
          repId: row.reportId,
          repTitle: row.reportTitle,
        },
      });
      // 
      // vm.$router.push('/statement/reportDetails')
    },
    async closeEditClass() {
      const vm = this;
      const editData =JSON.parse(JSON.stringify(vm.editClassData));
      let messageTitle = "添加成功";
      if (editData.repId) {
        messageTitle = "操作成功";
      } else {
        delete editData.repId;
      }
      vm.$refs["report-member-rights-form"].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        let { data, code } = await reportAdd(editData);
        if(code==200){
          vm.search();
            vm.$message.success(messageTitle);
        }
        // PlatformService.reportUpdate(editData).then((resultData) => {
        //   if (resultData) {
        //     vm.search();
        //     vm.$message.success(messageTitle);
        //   }
        // });
        vm.editClassData.visible = false;
      });
    },
    async editClass(row) {
      const vm = this;
      if (row.reportId) {
        //编辑
        vm.editLoading = true;
        vm.editClassData.title = "编辑报表";
        let { data, code } = await reportGet(vm.filter.page.pageIndex,vm.filter.page.pageSize,{reportId:row.reportId});
        if(code==200){
          data["title"] = "编辑报表";
              data["visible"] = true;
              vm.editClassData = data;
        }
        vm.editLoading = false;

        // PlatformService.reportGet(row.repId)
        //   .then((resultData) => {
        //     if (resultData.success) {
        //       resultData.data["title"] = "编辑报表";
        //       resultData.data["visible"] = true;
        //       vm.editClassData = resultData.data;
        //     }
        //     vm.editLoading = false;
        //   })
        //   .catch(() => {
        //     vm.editLoading = false;
        //   });
      } else {
        //新增
        vm.editClassData =JSON.parse(JSON.stringify(vm.initData));
        vm.editClassData.title = "新增报表";
     
      }
      vm.editClassData.visible = true;
    },
    async delClass() {
      const vm = this;
      if (vm.selectData.length === 0) {
        vm.$message.error("请选择一个选项");
        return false;
      }
      const list = [];
      this.$confirm("确认删除已选中的报表？")
        .then(async () => {
          vm.selectData.forEach((ele, index) => {
            list.push(ele.reportId);
          });
          let { data, code } = await reportDel({reportId: list });
          if(code==200){
            vm.search();
              vm.$message.success("删除成功");
          }
          // PlatformService.reportDelete({ ids: list }).then((resultData) => {
          //   if (resultData.success) {
          //     vm.search();
          //     vm.$message.success("删除成功");
          //   }
          // });
        })
        .catch((_) => {});
    },
    searchSize(e) {
      const vm = this;
      vm.filter.page.pageSize = e;
      vm.search();
    },
    searchCurrent(e) {
      const vm = this;
      vm.filter.page.pageIndex = e;
      vm.search();
    },
    importExcel() {
      const vm = this;
      vm.importExcelData.show = true;
    },
    async search() {
      const vm = this;
      vm.loading = true;
      let user = sessionStorage.getItem('user')&&JSON.parse(sessionStorage.getItem('user'))

      let obj={
        reportType:user.doctorId?2:1,
        reportTitle: this.filter.page.reportName
      }
      let { data, code } = await allReportList(vm.filter.page.pageIndex,vm.filter.page.pageSize,obj);
      if (code == 200) {
        data.data.forEach((ele, index) => {
             data.data[index].createDatetime = Utils.timeToDate(
                ele.createDatetime
              );
            });
            vm.listData = data.data;
            vm.filter.page.totalElements = data.totalElements;
      }
      this.loading = false;
    },
  },
  components: {},
};
</script>

<style scoped>

.content{
  background: #fff;
  padding:20px;
}
  .goodsClass {
    text-align: left;
  }
  .search{
    /deep/ .el-input{  
      /deep/ .el-input__inner{
      height: 33px !important;
    }
    /deep/ .el-input__icon {
      line-height: 33px;
    }
  }
}
</style>

